export const tipoComprobanteAdapter = (rawData) => {
  const { data } = rawData;
  if (data?.length > 0) {
    const rows = data?.map((item) => {
      const {
        IDTIPOCOMPROBANTE,
        DESCRIPCIONTIPOCOMPROBANTE,
        SIN_CAE
      } = item;

      return {
        id: IDTIPOCOMPROBANTE ?? null,
        descripcion: DESCRIPCIONTIPOCOMPROBANTE ?? null,
        sinCae: SIN_CAE ? (SIN_CAE === 'S') : false
      };
    });
    return { rows: rows };
  }
};

export const tiposSolicitudAdapter = (rawData) => {
  const { data } = rawData;
  if (data?.length > 0) {
    const rows = data?.map((item) => {
      const {
        ID,
        NOMBRE,
        OBSERVACION
      } = item;

      return {
        id: ID ?? null,
        nombre: NOMBRE?? null,
        descripcion: OBSERVACION?? null
      };
    });
    return { rows: rows };
  }
};
